import React, { useState } from 'react';
import {
  Modal,
  Box,
  Header,
  Button,
  SpaceBetween
} from '@cloudscape-design/components';
import Link from "@cloudscape-design/components/link";

function DocumentViewer({ 
  documentName, 
  documentPath, 
  linkVariant = "primary",
  linkText = null,
  pageNumber = null
}) {
  const [showModal, setShowModal] = useState(false);

  const displayText = linkText || documentName;
  
  // Add page parameter to PDF path if provided
  const pdfUrl = pageNumber ? `${documentPath}#page=${pageNumber}` : documentPath;

  return (
    <>
      <Link 
        href="#" 
        variant={linkVariant}
        onFollow={(e) => {
          e.preventDefault();
          setShowModal(true);
        }}
      >
        {displayText}
      </Link>

      <Modal
        visible={showModal}
        onDismiss={() => setShowModal(false)}
        header={`Document Viewer - ${documentName}`}
        size="large"
        footer={
          <Box float="right">
            <Button onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Box>
        }
      >
        <Box style={{ height: '900px', width: '100%', maxWidth: '1200px' }}>
          <iframe
            src={pdfUrl}
            title={documentName}
            width="100%"
            height="900px"
            style={{ border: 'none' }}
          />
        </Box>
      </Modal>
    </>
  );
}

export default DocumentViewer;
